import { isMobile, isSafari } from 'react-device-detect'

const MOBILE_BREAKPOINT = 900;

export function checkMobile() {
    return document.documentElement.clientWidth <= MOBILE_BREAKPOINT 
}